import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./BeginQuiz.css";
import { Link, useParams } from "react-router-dom";
import { useAuthStudent } from "../../../../context/StudentLoginContext/StudentAuthContext";
import "react-loading-skeleton/dist/skeleton.css";
import { StudentMapMenu } from "../../Map/MapMenu/MapMenu";
const BeginQuizesPageFestive = () => {
  const { questId, chapterId } = useParams();
  const { student, fetchWithAuthStudent } = useAuthStudent(); // Fetch student details from AuthContext
  const apiUrl = process.env.REACT_APP_API_URL;
  const [questChapterData, setQuestChapterFetchedData] = useState(null);

  useEffect(() => {
    const fetchChapterData = async () => {
      if (!student || !student.token) {
        return;
      }

      try {
        const response = await fetchWithAuthStudent(
          `${apiUrl}/student/quest-chapter/${chapterId}`,
          {
            method: "GET",
          }
        );

        if (!response.ok) {
          throw new Error("Failed to fetch chapters");
        }

        const data = await response.json();
        setQuestChapterFetchedData(data);
      } catch (error) {}
    };
    fetchChapterData();
  }, [apiUrl, student, questId, chapterId, fetchWithAuthStudent]);
  return (
    <>      
      <div
        className=" "
        style={{
          position: "relative",
          backgroundColor: "#0037ac",
          minHeight: "100vh",
          zIndex: 1,
        }}
      >
        <div className="container-fluid">
          <div className="teacher-bodycontent">
            <section>
              <div
                className="row justify-content-center"
                style={{ marginTop: "60px" }}
              >
                <div className="col-md-10 text-center">
                  <img
                    src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/quiz/QuizTime.png"
                    className="img-fluid  mx-auto"
                    style={{
                      position: "relative", // Ensures it stays above side images
                      zIndex: 3, // Higher than side images
                    }}
                    alt="quiz time"
                  />
                </div>
              </div>
            </section>

            <section>
              <div className="row justify-content-center">
                <div className="col-md-1"></div>
                <div className="col-md-10">
                  <div
                    className="position-relative text-center"
                    style={{ zIndex: 3 }}
                  >
                    <div style={{ color: "#fff", padding: "30px" }}>
                      <h1 style={{ marginBottom: "30px" }}>
                        {questChapterData?.chapter?.title}
                      </h1>

                      {/* <h4 style={{ marginBottom: "30px" }}>
                        {questChapterData?.chapter?.description}
                      </h4> */}

                      <div style={{ textAlign: "center", marginTop: "60px" }}>
                        <Link
                          to={`/student/admin/quiz/festive/${questId}/${chapterId}`}
                          style={{
                            backgroundColor: "#001F63", // Dark blue color
                            color: "#fff",
                            border: "2px solid #fff",
                            borderRadius: "40px",
                            padding: "20px 40px",
                            fontSize: "20px",
                            fontWeight: "bold",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          Begin Quiz &gt;
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-1"></div>
              </div>
            </section>
          </div>

          {/* Left Image */}
          <img
            src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/quiz/LeftSide.png"
            alt="left"
            className=" "
            style={{
              left: 0,
              position: "absolute",
              width: "auto",
              zIndex: 2,
              bottom: 0,
            }}
          />

          {/* Right Image */}
          <img
            src="https://d2lvj32mp5x83n.cloudfront.net/static/studentadmin/quiz/RightSide.png"
            alt="right"
            className=""
            style={{
              right: 0,
              width: "auto",
              zIndex: 2,
              position: "absolute",
              bottom: 0,
            }}
          />

          {/* Footer with highest z-index */}
          <div style={{ position: "relative", zIndex: 4 }}>
            <StudentMapMenu />
            {/* <StudentFooter /> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default BeginQuizesPageFestive;
